function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingConditions1 = function SvgLandingConditions1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 611 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: -48,
    width: 54.9136,
    height: 280,
    fill: "url(#paint0_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.91357,
    width: 56.6296,
    height: 280,
    fill: "url(#paint1_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.5432,
    width: 43,
    height: 280,
    fill: "url(#paint2_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.543,
    width: 44,
    height: 280,
    fill: "url(#paint3_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.543,
    width: 43,
    height: 280,
    fill: "url(#paint4_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.543,
    width: 45,
    height: 280,
    fill: "url(#paint5_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.543,
    width: 43,
    height: 280,
    fill: "url(#paint6_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.543,
    width: 43,
    height: 280,
    fill: "url(#paint7_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.543,
    width: 43,
    height: 280,
    fill: "url(#paint8_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.543,
    width: 43,
    height: 280,
    fill: "url(#paint9_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.543,
    width: 45,
    height: 280,
    fill: "url(#paint10_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.543,
    width: 45,
    height: 280,
    fill: "url(#paint11_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.543,
    width: 45,
    height: 280,
    fill: "url(#paint12_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.543,
    width: 45,
    height: 280,
    fill: "url(#paint13_linear_10_88)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.543,
    width: 45,
    height: 280,
    fill: "url(#paint14_linear_10_88)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_88",
    x1: -48,
    y1: 103.654,
    x2: 6.91358,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_88",
    x1: 6.91357,
    y1: 103.654,
    x2: 63.5432,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10_88",
    x1: 63.5432,
    y1: 103.654,
    x2: 106.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10_88",
    x1: 106.543,
    y1: 103.654,
    x2: 150.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10_88",
    x1: 150.543,
    y1: 103.654,
    x2: 193.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10_88",
    x1: 193.543,
    y1: 103.654,
    x2: 238.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10_88",
    x1: 238.543,
    y1: 103.654,
    x2: 281.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10_88",
    x1: 281.543,
    y1: 103.654,
    x2: 324.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10_88",
    x1: 324.543,
    y1: 103.654,
    x2: 367.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10_88",
    x1: 367.543,
    y1: 103.654,
    x2: 410.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10_88",
    x1: 410.543,
    y1: 103.654,
    x2: 455.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10_88",
    x1: 455.543,
    y1: 103.654,
    x2: 500.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10_88",
    x1: 500.543,
    y1: 103.654,
    x2: 545.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10_88",
    x1: 545.543,
    y1: 103.654,
    x2: 590.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10_88",
    x1: 590.543,
    y1: 103.654,
    x2: 635.543,
    y2: 103.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  }))));
};
export default SvgLandingConditions1;